"use client";
import heroImage from "../assets/hero.jpeg";
import { useNavigate } from "react-router-dom";
import { useQuery } from "@tanstack/react-query";
import Countdown from "../Countdown/Countdown";

const HeroSection = () => {
  const navigate = useNavigate();
  const { isLoading } = useQuery({ queryKey: ["authUser"] });

  const handleNavigation = (e, path) => {
    e.preventDefault();
    if (isLoading) return;
    navigate(path);
  };

  return (
    <div
      className="relative bg-cover bg-center h-screen" 
      style={{
        backgroundImage: `linear-gradient(to bottom, rgba(0, 0, 0, 0.6), rgba(0, 0, 0, 0.8)), url(${heroImage})`,
      }}
    >
      {/* Hero Content */}
      <div className="flex items-center justify-center pt-36 sm:pt-52 h-full px-6 lg:px-8">
        <div className="text-center max-w-4xl">
          <h1 className="text-3xl font-extrabold tracking-tight text-white sm:text-6xl drop-shadow-lg">
            52<sup>nd</sup> IMMUNOCON-2025
          </h1>
          <p className="text-md md:text-2xl text-gray-300 mt-4">
            [Annual conference of Indian Immunology Society]
          </p>
          <p className="text-md md:text-xl text-gray-300 mt-2">
            November 19-22, 2025
          </p>
          <p className="text-md md:text-xl text-gray-300 mt-1">
            @MNNIT Allahabad, Prayagraj
          </p>
          <p className="mt-8 text-md md:text-lg font-medium text-white sm:text-xl">
            Theme: Immunology Meets Technology - Improving the Effectiveness and Reach of Immunotherapy and Immunodiagnostics
          </p>
          <div className="mt-6">
            <Countdown
              targetDate="2025-11-19"
              className="text-2xl font-semibold text-indigo-300"
            />
          </div>
          <div className="flex items-center justify-center gap-x-6">
            <a
              href="/register"
              onClick={(e) => handleNavigation(e, "/register")}
              className="animate-bounce rounded-md bg-indigo-600 px-4 py-3 text-sm font-bold text-white shadow-lg hover:bg-gradient-to-r from-indigo-500 to-blue-600 transition duration-300"
            >
              Register Now
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default HeroSection;
